import URLConfig from './URLConfig';
import axiosInstance from "../util/axiosInstance";

const path = URLConfig.getBasePath();

class ShopService {

    updateCategory(formData) {
        let config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        return axiosInstance().post(path + "/shop/category", formData, config);
    }

    addNewShopItem(formData) {
        let config = {
            headers: { 'content-type': 'multipart/form-data' }
        }
        return axiosInstance().post(path + "/shop/category/item", formData, config);
    }

    updateShopItem(formData) {

        return axiosInstance().put(path + "/shop/category/item", formData);
    }

    getShopCategoryList(categoryId) {
        return axiosInstance().get(path + "/shop/category/" + categoryId);
    }

    deleteCategory(categoryId) {
        return axiosInstance().delete(path + "/shop/category/" + categoryId);
    }

    updateSize(formData) {
        return axiosInstance().post(path + "/item/size", formData);
    }

    deleteSize(sizeId) {
        return axiosInstance().delete(path + "/item/size/" + sizeId);
    }

    // brands: { id, name, productCount }; an empty list comes back without `data`
    getBrands() {
        return axiosInstance().get(path + "/shop/brands");
    }

    saveBrand(brandId, name) {
        return brandId
            ? axiosInstance().put(path + "/shop/brands/" + brandId, { name })
            : axiosInstance().post(path + "/shop/brands", { name });
    }

    deleteBrand(brandId) {
        return axiosInstance().delete(path + "/shop/brands/" + brandId);
    }

    deleteItem(itemId) {
        return axiosInstance().delete(path + "/shop/items/remove/" + itemId);
    }
}

export default new ShopService()